import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import es from './locales/es.json';

export const DG_LANG_STORAGE_KEY = 'dg_lang';
const DEFAULT_LANG = 'en';

function syncDocumentLang(lng: string) {
  if (typeof document === 'undefined') return;
  const base = (lng || DEFAULT_LANG).split('-')[0];
  document.documentElement.lang = base === 'es' ? 'es' : 'en';
}

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, es: { translation: es } },
  lng:
    typeof window !== 'undefined'
      ? localStorage.getItem(DG_LANG_STORAGE_KEY) || DEFAULT_LANG
      : DEFAULT_LANG,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

syncDocumentLang(i18n.language);

i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem(DG_LANG_STORAGE_KEY, lng);
  } catch {
    // ignore quota / private mode
  }
  syncDocumentLang(lng);
});

/** Persist and apply UI language (en | es). */
export function setAppLanguage(lng: string) {
  void i18n.changeLanguage(lng);
}

export default i18n;
